import client from './client';

export interface SmsSendResponse {
  message: string;
  cooldown_seconds: number;
  expires_in_seconds: number;
  test_mode: boolean;
}

export interface SmsVerifyResponse {
  message: string;
  verified: boolean;
}

export const sendCode = async (
  phone: string,
  purpose: 'signup' | 'password_reset' | 'phone_change',
): Promise<SmsSendResponse> => {
  const res = await client.post('/api/v1/sms/send', { phone, purpose });
  return res.data;
};

export const verifyCode = async (
  phone: string,
  purpose: 'signup' | 'password_reset' | 'phone_change',
  code: string,
): Promise<SmsVerifyResponse> => {
  const res = await client.post('/api/v1/sms/verify', { phone, purpose, code });
  return res.data;
};
